/*
 * @Description: 各学院转专业情况
 * @Author: lisenlin
 * @Date: 2021-08-27 01:08:59
 * @LastEditors: lisenlin
 * @LastEditTime: 2021-08-28 15:12:13
 */

import React from 'react'
import echarts from "echarts/lib/echarts";
import Echarts from '../../../components/common/Echarts/index'
import css from '../index.css'

export default function CollegeChangeMajor(props) {
    let list = props.changeMajorList
    /**
     * 渲染学院转专业的option
     * @param {*} list 数据
     * @returns option
     */
    const getBarOption = (list) => {
        let xyList = [], ZRCSList = [], ZCCSList = [], JZRRSList = [];
        list.length>0&&list.map(item=>{
            xyList.push(item.BMMC)
            ZRCSList.push(item.ZRCS)
            ZCCSList.push(item.ZCCS)
            JZRRSList.push(item.JZRRS)
        })
        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999'
                    }
                }
            },
            legend: {
                data: ['转入人数', '转出人数', '净转入人数'],
                bottom: 0
            },
            grid: {
                top: 20,  //坐标轴距离上边间距
                left: 30,
                right: 40,
                bottom: 100
            },
            xAxis: [
                {
                    type: 'category',
                    data: xyList,
                    axisPointer: {
                        type: 'shadow'
                    },
                    boundaryGap: true,
                    axisTick: {
                        show: false,   //不显示刻度
                    },
                    axisLabel: {
                        show: true,
                        rotate: 45,    //刻度标签旋转  0-90 度
                        formatter: function(value){
                            return value.length > 7 ? value.substring(0, 7) + '...' : value;
                        }
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    // name: '人数',
                    // min: 0,
                    // max: 250,
                    // interval: 5,
                    axisLabel: {
                        formatter: '{value} '
                    },
                    axisTick: {
                        show: false,   //不显示刻度
                    },
                },
                {
                    type: 'value',
                    // name: '温度',
                    // min: -15,
                    // max: 25,
                    // interval: 5,
                    axisLabel: {
                        formatter: '{value}'
                    },
                    axisTick: {
                        show: false,   //不显示刻度
                    },
                }
            ],
            series: [
                {
                    name: '转入人数',
                    type: 'bar',
                    data: ZRCSList,
                    barMaxWidth: 30,    //柱体的最大宽度
                    barCategoryGap: "30%",  //不同系列的柱体间隔
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [
                                    {offset: 0, color: '#5BBDFF'},
                                    {offset: 0.5, color: '#5AA9FF'},
                                    {offset: 1, color: '#4C90FF'}
                                ]
                            ),
                            barBorderRadius: [5, 5, 0, 0]
                        }
                    },
                },
                {
                    name: '转出人数',
                    type: 'bar',
                    data: ZCCSList,
                    barMaxWidth: 30,    //柱体的最大宽度
                    barCategoryGap: "30%",  //不同系列的柱体间隔
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [
                                    {offset: 0, color: '#B8E8DE'},
                                    {offset: 0.5, color: '#01C8A8'},
                                    {offset: 1, color: '#00CFBB'}
                                ]
                            ),
                            barBorderRadius: [5, 5, 0, 0]
                        }
                    },
                },
                {
                    name: '净转入人数',
                    type: 'line',
                    yAxisIndex: 1,
                    data: JZRRSList,
                    itemStyle: {
                        normal: {
                            color: '#B08B62'
                        }
                    }
                }
            ]
        }
    }

    return (
        <div className={css.cardWarp}>
            <div className={css.title}>各学院转专业情况</div>
            <Echarts
                style={{height: '400px'}}
                option={getBarOption(list)}
            />
        </div>
    )
}



// WEBPACK FOOTER //
// ./components/changeMajorStaic/collegeChangeMajor/index.js